import { render, staticRenderFns } from "./MarkAsDoneDisposal.vue?vue&type=template&id=23074645"
import script from "./MarkAsDoneDisposal.vue?vue&type=script&lang=js"
export * from "./MarkAsDoneDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports